export default "__VITE_ASSET__YpVaqYIZ__"